/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} History_Empty_ActionInputs */

const en_history_empty_action = /** @type {(inputs: History_Empty_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go to recipes`)
};

const de_history_empty_action = /** @type {(inputs: History_Empty_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zu den Rezepten`)
};

/**
* | output |
* | --- |
* | "Go to recipes" |
*
* @param {History_Empty_ActionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const history_empty_action = /** @type {((inputs?: History_Empty_ActionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<History_Empty_ActionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_history_empty_action(inputs)
	return en_history_empty_action(inputs)
});